module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAP1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8e20umdxOH///+Ftdpgns5Ul8vz+Pva6fTO4fB4rdbn8PhsptJydb/uAAAACHRSTlMAYL//ACDP71kzCuAAAAD2SURBVHgB7dhxcoMgEEZxFDWLHwhq73/Wmkynk9IEF3f/yvAO8DvAM/e63grqu+HIDMM4WWHTeIfGmxV3Gw9osgpNg+msSp3pdaDeWKUa9KkQkRLknA40A7MG5HHk5VDAoyCFlohHcZFBlPBTIhG04rdVAjk85a5DHn/yV6ENWds1KERkxXAFoh3/2qkeooQXJaqGHF7maqEZb5rrII+3+RoooFDgQ0tEobhwIUoologJrThp5UEOpzkO5MHIn0MbWH2dQSGCVQxliHYw26kEUQK7VIKykGXzGtSgBjXo8yFhDWqQ2mRR2z5qI0pvjanNuiONffgNZhlZ8GVVgcMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2b06.png
// module id = 1418
// module chunks = 0